<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space clickable" @click="msgAlerta=null"><span class="text">{{ msgAlerta }}</span></div>


    <div v-if="((!modoEdicao) && (!modoVisualizacao))">
        <div class="form-edit-page row-space">
            <div class="row-start">
                <div class="form-item-rangedata"><DateRangeSelect :periodoInicial="'currentMonth'" v-model="dateRange" /></div>
                <button class="btn-small" @click="lerDados">Ler Dados</button>
                <button class="btn-small" @click="closeForm">Voltar</button>
            </div>
        </div>
        

        <div v-if="lsDados.length>0">
            <div class="table-wrapper">
                <table>
                    <thead>
                        <tr>
                            <th>O.S.</th>
                            <th>Data</th>
                            <th>Execução</th>
                            <th>Bairro</th>
                            <th>Serviço</th>
                            <th>Prestador</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(obj, index) in lsDados" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}"  @click="visualizarIpOS(obj)">
                            <td class="col-width-char10 right">{{ obj.cdipos }}</td>
                            <td class="col-width-char10 center">{{ Funcoes.formatDateFromJson(obj.dtipos) }}</td>
                            <td class="col-width-char10 center">{{ Funcoes.formatDateFromJson(obj.dtfim) }}</td>
                            <td class="col-width-char30">{{ obj.nmbairro }}</td>
                            <td>{{ obj.nmipservico }}</td>
                            <td class="col-width-char40">{{ obj.nmfornecedor }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div v-if="showPagination" class="pagination">
                <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
                <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
                <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
                <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
                <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
            </div>
        </div>
    </div>


    <div v-if="modoVisualizacao">
        <IpOSExecutadaViewPage :idView="idView" @close="modoVisualizacao = false" />
    </div>
</template>


<script setup>
import { onMounted, ref } from 'vue';
import { Funcoes } from '@/funcoes/utils';
import { genericPost } from '@/funcoes/api'; 
import { globalStore } from '@/globals';
import DateRangeSelect from '@/components/DateRangeSelect.vue';
import IpOSExecutadaViewPage from '../visualizacoes/IpOSExecutadaViewPage.vue';

const emit = defineEmits(['close']);

const dateRange = ref({ startDate: "", endDate: "", selectedPeriod: "" });
const msgAlerta = ref(null);
const idView = ref(0);
const isLoading = ref(false);
const lsDados = ref([]);
const modoEdicao = ref(false);
const modoVisualizacao = ref(false);

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showPagination = ref(false);

const closeForm = () => {emit('close');}


async function lerDados() {
    try{
        Funcoes.validarIntervaloDatas(dateRange.value.startDate, dateRange.value.endDate);
        msgAlerta.value = null;
        isLoading.value = true;
        const req = await genericPost('/ip/ipos/executadas', {
            idmunicipio: globalStore.idmunicipio,
            datainicial: dateRange.value.startDate, 
            datafinal:dateRange.value.endDate});
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}


const updatePaginatedData = () => {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}


const visualizarIpOS = (obj) =>{
    idView.value = obj.id;
    modoVisualizacao.value = true;
}

onMounted(lerDados);
</script>
